import React from "react";
import "./styles/Deposit.scss";

export const TransactionTermsField = (props: {onClick:()=>void}) => {
    return(
        <div>
            <label className="col-form-label">PLEASE AGREE TO THE TERMS</label>
            <div className="deposit-form summary">
                I agree to pay the amount indicated above, using the checking account information listed. I understand this amount will be debited from the checking
                account using a check draft or electronic check debit.<br/><br/> I understand that once I press the Submit Payment button below,
                I will not be able to stop the payment from processing.
            </div>
            <div className="custom-control custom-checkbox">
                <label className="checkbox-label" htmlFor="customCheck">
                    <input onClick={()=>props.onClick()} type="checkbox" className="deposit-form rectangle" id="customCheck"/>
                     I agree with these Transaction Terms
                </label>
            </div>
        </div>
    )
};